// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".missed-milestones{color:#666}.missed-milestones span.description{color:#007bff;cursor:pointer;display:block;width:350px}.missed-milestones .alt-color{background-color:#efefef}.missed-milestones .days-ago{color:#afafaf}.missed-milestones hr{margin-bottom:7px;margin-top:7px}", ""]);
// Exports
module.exports = exports;
